var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 17.5007C13.6784 17.5007 16.6693 14.5099 16.6693 10.834C16.6693 8.04237 14.9426 5.64987 12.5026 4.6582V6.5107C13.2617 6.94897 13.8923 7.57909 14.331 8.33789C14.7698 9.09669 15.0014 9.95751 15.0026 10.834C15.0026 13.5915 12.7601 15.834 10.0026 15.834C7.2451 15.834 5.0026 13.5915 5.0026 10.834C5.00371 9.95749 5.23527 9.09664 5.67406 8.33782C6.11285 7.57901 6.74345 6.9489 7.5026 6.5107V4.6582C5.0626 5.64987 3.33594 8.04237 3.33594 10.834C3.33594 14.5099 6.32677 17.5007 10.0026 17.5007Z",
    fill: "#74788D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 1.66602H10.8307V9.99935H9.16406V1.66602Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPowerOff);
export default __webpack_public_path__ + "static/media/bx-power-off.b36c262c18ee304dc5242c21e861a682.svg";
export { ForwardRef as ReactComponent };